import { DOCUMENT } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SettingDataOutputModel } from '@travel/shared';
import { DataConfig, FontService, ScrollToTopService, ThemeService } from '@travel/shared/services';
import { environment } from '../environments/environment';
import { ManifestService } from './manifest.service';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'travel-btc-workspace-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [ScrollToTopService],
})
export class AppComponent implements OnInit {
  title = 'hotel-wl';
  settingData: SettingDataOutputModel = DataConfig.get('globalSetting');

  // services
  manifestService = inject(ManifestService);
  fontService = inject(FontService);
  themeService = inject(ThemeService);
  document: any = inject(DOCUMENT);
  _ScrollToTopService: any = inject(ScrollToTopService);

  env: string = environment.picturesURL;
  ngOnInit(): void {
    this.themeService.setTheme(DataConfig.get('globalSetting').themeColor);

    // Call the service method to update the manifest
    this.manifestService.updateManifest(DataConfig.get('globalSetting').brandName, DataConfig.get('globalSetting').slogan);

    // this.themeService.setTheme(this.settingData.themeColor);

    this.fontService.init();

    // this.themeService.detectTheme();

    this.document.getElementById('appIcon').setAttribute('href', `${this.env}/${this.settingData.logo}`);
  }
}
